import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/api';
import { broadcastLogout, listenCrossTabLogout } from '../utils/crossTabAuthSync';

const PatientAuthContext = createContext(null);

export const PatientAuthProvider = ({ children }) => {
  const [patient, setPatient] = useState(() => {
    const saved = localStorage.getItem('patient_user');
    try {
      return saved ? JSON.parse(saved) : null;
    } catch {
      return null;
    }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(false);
    const unsubscribe = listenCrossTabLogout(() => {
      setPatient(null);
      if (window.location.pathname.startsWith('/portal/patient')) {
        window.location.href = '/portal/login';
      }
    });
    return unsubscribe;
  }, []);

  const login = (userData, explicitToken = null) => {
    // Note: Backend sets HttpOnly cookie for actual auth.
    // Set UI user metadata and session indicator flag in localStorage.
    setPatient(userData);
    if (userData) {
      localStorage.setItem('patient_user', JSON.stringify(userData));
    }
    const tokenVal = explicitToken || (userData && typeof userData.token === 'string' ? userData.token : null) || localStorage.getItem('patient_token');
    if (tokenVal && typeof tokenVal === 'string' && tokenVal.length > 20) {
      localStorage.setItem('patient_token', tokenVal);
    }
    localStorage.setItem('login_event', Date.now().toString());
    window.dispatchEvent(new Event('local-storage-update'));
  };

  const logout = () => {
    try { api.post('/api/logout/').catch(() => {}); } catch (e) {}
    setPatient(null);
    broadcastLogout('patient');
  };

  const value = {
    patient,
    token: localStorage.getItem('patient_token'),
    loading,
    login,
    logout,
    isAuthenticated: !!patient
  };

  return <PatientAuthContext.Provider value={value}>{children}</PatientAuthContext.Provider>;
};

export const usePatientAuth = () => {
  const context = useContext(PatientAuthContext);
  if (!context) {
    throw new Error('usePatientAuth must be used within a PatientAuthProvider');
  }
  return context;
};
